<template>
  <div class="info-box">
    <div class="info-box-title">Still need our help?</div>
    <div class="info-box-text">Contact us through email.</div>
    <button class="info-box-button">Contact us</button>
  </div>
</template>

<script>
export default {
  name: "StillNeedHelp",
};
</script>

<style scoped>
.info-box {
  width: 242px;
  margin: 0 auto;
  padding: 20px 10px 5px;
  border-radius: 12px;
  background-color: hsla(0, 0%, 97.6%, 0.79);
  box-shadow: rgb(15 15 15 / 5%) 0px 0px 0px 1px,
    rgb(62 62 62 / 10%) 0px 3px 6px, rgb(193 193 193 / 20%) 0px 9px 24px;
  box-sizing: border-box;
  margin-bottom: 40px;
  display: flex;
  flex-direction: column;
}
.info-box-title {
  font-weight: 600;
  padding: 8px 14px;
  height: 42px;
  margin-right: 8px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  border: 1px solid transparent;
  font-size: 22px;
  line-height: 22px;
}
.info-box-text {
  font-weight: 600;
  padding: 8px 14px;
  height: 42px;
  margin-right: 8px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  border: 1px solid transparent;
  font-size: 16px;
  font-weight: 400;
  margin-top: 10px;
}
.info-box-button {
  margin-right: 8px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  cursor: pointer;
  border: 1px solid transparent;
  font-size: 16px;
  font-weight: 400;
  margin-top: 10px;
  font-size: 18px;
  margin-top: 10px;
  background-color: #111;
  color: white;
  font-weight: 700;
  border-radius: 360px;
  width: 140px;
  margin-left: 10px;
  margin-bottom: 10px;
  padding: 4px 13px;
  height: 35px;
}
.info-box-button:hover {
  background-color: #454545;
}
</style>